<template>
  <div
    class="msgs-container lang-dir"
    :class="{ 'full-height': allMessages && messages.length }"
    v-if="ready && (showMsgsContainer || allMessages)"
  >
    <div
      class="msgs-container lang-dir"
      :class="{ 'auto-scroll': allMessages }"
      v-if="showMsgsContainer"
      style="padding: 0px"
      v-kiosk
    >
      <div class="msgs-container-header">
        <Icons icon="alarm" height="24px" width="24px" style="fill: white" />
        <p class="title-msgs">
          {{ $t("messages.youHave") }} {{ messages.length }}
          {{ $t("messages.msgs") }}
          <span v-if="allMessages && unreadMessages.length > 0"
            >( {{ unreadMessages.length }} {{ $t("messages.new") }} )</span
          >
        </p>
        <button
          v-if="!toggleMsgs && !allMessages"
          class="btn btn-primray"
          @click="toggleMsgs = !toggleMsgs"
        >
          {{ $t("messages.showMore") }}
        </button>
        <!-- <button v-else class="btn btn-primray" @click="toggleMsgs = !toggleMsgs">
        {{ $t("messages.showLess") }}
      </button> -->
        <button
          class="btn btn-primray close-msg-btn"
          @click="toggleMsgs = !toggleMsgs"
          v-if="toggleMsgs && !allMessages"
        >
          <Icons icon="exit" height="9px" width="9px" fill="white" />
        </button>
      </div>
      <div class="info">{{ $t("messages.readingMsg") }}</div>
      <div
        :class="{ 'no-max-height': allMessages }"
        class="msg-content-container"
        v-show="toggleMsgs || allMessages"
      >
        <div v-for="msg in messages" :key="msg.id" style="position: relative">
          <div class="msg-header flex-row">
            <div
              class="flex"
              v-if="!msg.msgRead"
              style="
                padding-right: 10px;
                padding-bottom: 30px;
                padding-right: 28px;
              "
            >
              <baseCheckBox
                :checked="false"
                @change="setMessageRead(msg.id)"
                size="larg"
              />
              <span>
                {{ $t("login.dontshow") }}
              </span>
            </div>
          </div>
          <PerosnalAreaMsg
            :html="msg.data"
            v-show="toggleMsgs || allMessages"
            class="msg"
          ></PerosnalAreaMsg>
          <!-- <div
            v-html="msg.data"
            v-show="toggleMsgs || allMessages"
            class="msg"
          ></div> -->
        </div>
      </div>
    </div>
    <div class="title-msgs" v-if="!showMsgsContainer && allMessages">
      {{ $t("messages.noMessages") }}
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import Icons from "@/components/Icons/Icons.vue";
import { mapGetters, mapActions } from "vuex";
import PerosnalAreaMsg from "./PersonalAreaMsg.vue";
import moment from "moment";
export default {
  components: { Icons, PerosnalAreaMsg },
  data() {
    return {
      message: "",
      cookie: "office_message",
      activeMsg: 1,
      messageId: 0,
      toggleMsgs: false,
      closed: false,
      ready: false,
    };
  },
  props: {
    dontShowAgain: { default: true },
    allMessages: { default: false },
  },
  computed: {
    ...mapGetters("officeMessages", ["getMessages"]),
    unreadMessages() {
      try {
        return this.messages.filter((m) => !m.msgRead);
      } catch {
        return [];
      }
    },
    showMessage() {
      if (localStorage.getItem(this.cookie) >= this.messageId) return false;

      return this.show;
    },
    showMsgsContainer() {
      if (this.$store.state.firstTimeMsg) {
        this.closed = false;
        this.toggleMsgs = true;
        this.$store.state.firstTimeMsg = false;
      }
      return this.messages.length > 0 && !this.closed;
    },
    messages() {
      return this.getMessages;
    },
  },
  async mounted() {
    this.ready = true;
  },
  methods: {
    ...mapActions("officeMessages", ["removeMessage"]),
    setMessageRead(msgId) {
      this.removeMessage(msgId);
      const notification = {
        type: "success",
        message: "ההודעה לא תוצג יותר. תוכל לצפות בה באזור האישי - ההודעות שלי",
        timeout: 10000,
      };
      this.$notify(notification);
    },
    formatDate(dt) {
      return moment(dt).format("DD.MM.YYYY / HH:mm");
    },
    closeMsgContainer() {
      this.closed = true;
    },
    prev() {
      if (this.activeMsg > 1) this.activeMsg--;
    },
    next() {
      if (this.activeMsg < this.messages.length) this.activeMsg++;
    },
    setDontShow(e) {
      if (e.target.checked) localStorage.setItem(this.cookie, this.messageId);
      else localStorage.setItem(this.cookie, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  align-self: stretch;
  color: rgba(255, 255, 255, 0.5);
  padding-right: 10px;
  padding-left: 10px;
  /* label */
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%; /* 13.2px */
}
button {
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.15);
}
.msgs-container-header {
  width: 100%;
  display: flex;
  max-width: 100%;
  gap: 3px;
}
.msgs-container {
  display: flex;
  padding: 8px 5px;
  margin-top: 2px;
  max-height: 600px;
  align-items: center;
  gap: 15px;
  justify-content: space-between;
  flex-direction: column;
  align-self: stretch;
  //position: absolute;
  //bottom: 0px;
  //margin: 8px;
  //border-radius: 8px;
  /*background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0.5) 100%
    ),
    #a7610f;*/
  background-color: var(--custom-color2);
  width: 100%;
}
.msg-content-container {
  max-height: 400px;
  overflow-y: auto;
  display: flex;
  margin: 8px;
  flex-direction: column;
  gap: 8px;
  padding: 5px;
  transition: height 0ms 0ms, opacity 400ms 0ms;
  width: 100%;
}
.msg {
  min-height: 150px;
  padding: 15px 10px;
  background-color: white;
  border-radius: 5px;
  background: #fff;
  box-shadow: 2px 4px 4px 0px rgba(0, 0, 0, 0.25);
  width: 100%;
  justify-content: center;
  flex-direction: column;
  //max-height: 400px;
  overflow: auto;
  align-items: center;
  display: flex;
  transition: all 0.2s ease-out;
}
.close-msg-btn {
  width: 10px;
  padding: 8px;
  display: flex;
  align-items: center;
}
.title-msgs {
  color: #fff;
  flex: 1;
  font-size: 13px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
}
.read-btn {
  background: #533007;
  color: white;
  padding-top: 2px;
}
.msg-header {
  position: absolute;
  top: 4px;
  right: 4px;
  justify-content: space-between;
  width: 100%;
}
.msg-date {
  position: absolute;
  left: 10px;
  top: 2px;
}
.no-msg {
  color: white;
}
.full-height {
  height: auto;
  // height: 100%;
  max-height: 100% !important;
}
.auto-scroll {
  max-height: none !important;
  overflow: auto;
  overflow-x: hidden;
}
.no-max-height {
  max-height: none !important;
}
</style>
